import { render, staticRenderFns } from "./salesPivot.vue?vue&type=template&id=3e589811&scoped=true&"
import script from "./salesPivot.vue?vue&type=script&lang=js&"
export * from "./salesPivot.vue?vue&type=script&lang=js&"
import style0 from "./salesPivot.vue?vue&type=style&index=0&id=3e589811&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e589811",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VDivider,VIcon,VRow,VSubheader})
